module.exports = __webpack_public_path__ + "img/annual-user@2x.89093d75.png";